import { FETCH_DUYURULAR_SUCCESS } from "../actions/duyurularAction";

const initState = {
    duyurular: [],
    pagination: null,
};

const duyurularReducer = (state = initState, action) => {
    if (action.type === FETCH_DUYURULAR_SUCCESS) {
        return {
            ...state,
            duyurular: action.payload.duyurular || action.payload, // Backward compatibility
            pagination: action.payload.pagination || null,
        };
    }

    return state;
};

export default duyurularReducer;
